import styled from 'styled-components';

const ToggleButton = styled.button`
  height: 2.5rem;
  width: 2.5rem;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 1rem;
    height: auto;
  }
`;

export default ToggleButton;
